import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function canBeDeleted(records, ids) {
  const errors = initialErrorState();
  const binsWithContents = records.filter(
    ({ id, contents }) => ids.includes(id) && contents.length
  );
  if (binsWithContents.length) {
    const contents = binsWithContents.map(({ number }) => number).join(", ");
    errors.messages.push(i18n("bin.batchDeleteDisabled", { contents }));
  }
  return errors;
}
